import { capsuleStyle } from "@/lib/yuoDesign";
import { useTheme } from "@/lib/theme";

const ICON = {
  day: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8" />
    </>
  ),
  night: <path d="M14.5 3.5a8.5 8.5 0 1 0 6 14.4A9.5 9.5 0 0 1 14.5 3.5z" />,
};

// Day / Night pill — same capsule as History, monochrome outline glyph.
export default function ThemeToggle({ size = "md", compact = false }) {
  const [theme, toggle] = useTheme();
  const isDay = theme === "day";
  if (compact) {
    return (
      <button type="button" data-testid="theme-toggle" aria-label={isDay ? "Switch to night" : "Switch to day"} onClick={toggle}
        style={{
          width: 40, height: 40, borderRadius: "50%", border: "none", padding: 0, flex: "0 0 auto", cursor: "pointer",
          background: "var(--m-more-bg)", color: "var(--yuo-ink)", display: "grid", placeItems: "center", boxShadow: "none",
        }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          {isDay ? ICON.day : ICON.night}
        </svg>
      </button>
    );
  }
  return (
    <button type="button" data-testid="theme-toggle" aria-label={isDay ? "Switch to night" : "Switch to day"}
      onClick={toggle} style={{ ...capsuleStyle({ active: false, size }), gap: 10 }}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        {isDay ? ICON.day : ICON.night}
      </svg>
      {isDay ? "День" : "Ночь"}
    </button>
  );
}
